import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value"];
import * as React from 'react';
import { invoke } from '../../../../internal/utils';
import { formatDateValueToHTML } from '../../utils';
export var NativeDateInput = /*#__PURE__*/React.forwardRef(function NativeDateInput(props, ref) {
  var value = props.value,
    rest = _objectWithoutProperties(props, _excluded);
  var handleChange = function handleChange(e) {
    invoke(props.onChange, toDateValue(e.currentTarget.value));
  };
  return /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    ref: ref,
    type: "date",
    defaultValue: formatDateValueToHTML(value || props.defaultValue),
    onChange: handleChange,
    min: formatDateValueToHTML(props.min),
    max: formatDateValueToHTML(props.max)
  }));
});
function toDateValue(value) {
  return value && new Date(value) || null;
}